import {fork} from 'redux-saga/effects';
import account from './account';
import companies from './companies';
import contacts from './contacts';
import books from './books';
import dashboard from './dashboard';
import jobsList from './jobsList';
import opportunitiesList from './opportunitiesList';
import opportunity from './opportunity';
import products from './products';
import sales from './sales';
import salesList from './salesList';
import admin from './admin';
import divisions from './divisions';
import eventsOverview from './eventsOverview';
import users from './users';

export default function* rootSaga() {
    yield fork(account);
    yield fork(opportunity);
    yield fork(sales);
    yield fork(contacts);
    yield fork(companies);
    yield fork(books);
    yield fork(products);
    yield fork(dashboard);
    yield fork(jobsList);
    yield fork(opportunitiesList);
    yield fork(salesList);
    yield fork(divisions);
    yield fork(admin);
    yield fork(eventsOverview);
    yield fork(users);
}